import { render, staticRenderFns } from "./TermsForm.vue?vue&type=template&id=45be9b5e&scoped=true&"
import script from "./TermsForm.vue?vue&type=script&lang=js&"
export * from "./TermsForm.vue?vue&type=script&lang=js&"
import style0 from "./TermsForm.vue?vue&type=style&index=0&id=45be9b5e&scoped=true&lang=css&"
import style1 from "./TermsForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be9b5e",
  null
  
)

export default component.exports